import React from "react";
import { ArrowRight, Phone, ShieldCheck, Building2, House as Home, Umbrella, Layers } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const features = [{
  icon: Building2,
  title: "Commercial",
  desc: "Main contractors and commercial fit-outs"
}, {
  icon: Home,
  title: "Residential",
  desc: "Renovations, extensions and domestic access"
}, {
  icon: Umbrella,
  title: "Roofing & Solar",
  desc: "Temporary roofs, edge protection and solar arrays"
}, {
  icon: Layers,
  title: "Specialist Access",
  desc: "Confined sites, pavement licences and complex design"
}];
const accreditations = ["NASC Member", "CHAS Accredited"];
export default function Wandsworth() {
  return <section id="wandsworthhero" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground pt-32 pb-20 md:pt-40 md:pb-28">
      {/* Subtle architectural grid pattern overlay */}
      <div className="absolute inset-0 pointer-events-none opacity-5 bg-[linear-gradient(to_right,rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:4rem_4rem]" aria-hidden="true" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          
          {/* Location Badge */}
          <div className="inline-flex items-center gap-2">
            <Badge variant="outline" className="border-sidebar-border bg-sidebar-accent/50 text-secondary-foreground text-xs uppercase tracking-wider font-medium px-3.5 py-1.5 rounded-full">
              <ShieldCheck className="size-3.5 text-primary-foreground mr-1" />
              Wandsworth &amp; South West London
            </Badge>
          </div>

          {/* Primary H1 Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-secondary-foreground font-default">
            Scaffolding in Wandsworth
          </h1>

          {/* Proposition Description - Answer-First Copy */}
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            BMF Scaffolding provides commercial, residential, roofing, solar and specialist scaffolding in Wandsworth and the surrounding South West London area, including SW18.
          </p>

          {/* Action CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <Button size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-medium px-7 shadow-md" asChild>
              <Link to="/ContactRequestQuotePage">
                Request a Quote
                <ArrowRight className="size-4 ml-1.5" />
              </Link>
            </Button>

            <Button size="lg" variant="outline" className="w-full sm:w-auto border-sidebar-border bg-secondary hover:bg-sidebar-accent text-secondary-foreground hover:text-secondary-foreground rounded-md font-medium px-6" asChild>
              <a href="tel:01344929900" className="text-secondary-foreground hover:text-secondary-foreground inline-flex items-center">
                <Phone className="size-4 mr-2 text-secondary-foreground" />
                Call 01344 929900
              </a>
            </Button>
          </div>

          {/* Accreditations Trust Bar */}
          <div className="pt-6 border-t border-sidebar-border/60">
            <p className="text-xs uppercase tracking-wider text-muted-foreground mb-3 font-medium">
              Verified Industry Accreditations
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4">
              {accreditations.map((item, i) => <div key={item} data-index={i} className="inline-flex items-center gap-1.5 text-xs text-secondary-foreground/90 bg-sidebar-accent/30 border border-sidebar-border px-3 py-1 rounded-md">
                  <ShieldCheck className="size-3.5 text-chart-4" />
                  <span>{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* 4 Core Scaffolding Disciplines Grid */}
        <div className="mt-16 sm:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.title} data-index={i} className="bg-sidebar-accent/20 border border-sidebar-border rounded-lg p-5 text-left transition-[border-color,background-color] duration-200 hover:border-sidebar-border/80 hover:bg-sidebar-accent/40">
                <div className="size-10 rounded-md bg-sidebar-accent border border-sidebar-border flex items-center justify-center mb-4 text-secondary-foreground">
                  <Icon className="size-5" />
                </div>
                <h2 className="text-base font-semibold text-secondary-foreground mb-1 font-default">
                  {feature.title}
                </h2>
                <p className="text-sm text-muted-foreground leading-snug">
                  {feature.desc}
                </p>
              </div>;
        })}
        </div>

      </div>
    </section>;
}